export default __webpack_public_path__ + "static/media/3.5a63d0b8.png";